import { SyncStage } from "~shared/Connection";
import { enumify, AppName, GameName } from "../messageTypes";

export enum PlayerJoinStateName {
  SPECTATOR,
  JOINING,
  IN_GAME,
  LEAVING,
}

export type UserInfo = {
  id: string;
};

export interface PlayerInfo {
  id: string;
  name: string;
  joinState: PlayerJoinStateName;
}

export enum EndGameAction {
  WAIT,
  NEXT_GAME,
  RETURN_TO_LOBBY,
}

export interface RoomInfo {
  roomCode: string;
  players: PlayerInfo[];
  gamesPlayed: number;
  currentGame: AppName;
}

export namespace BaseServer {
  const _Types = [
    "SYNC",
    "USER_INFO",
    "ROOM_INFO",
    "LOBBY_INFO",
    "MESSAGE",
    "GAME_STARTED",
    "TOKEN",
  ] as const;
  export const TypeValue = enumify("BaseServer", _Types);
  export type Type = typeof TypeValue;

  export type UserInfoMessage = {
    type: Type["USER_INFO"];
    data: UserInfo;
  };

  export type RoomInfoMessage = {
    type: Type["ROOM_INFO"];
    data: RoomInfo;
  };

  export type MessageMessage = {
    type: Type["MESSAGE"];
    data: {
      toast: boolean;
      history: boolean;
      text: string;
    };
  };

  export type GameStartedMessage = {
    type: Type["GAME_STARTED"];
    data: number;
  };

  export type TokenMessage = {
    type: Type["TOKEN"];
    data: string;
  };

  export type Message =
    | UserInfoMessage
    | RoomInfoMessage
    | MessageMessage
    | GameStartedMessage
    | TokenMessage;
}

export namespace BaseClient {
  const _Types = [
    "SYNC",
    "JOIN_GAME",
    "LEAVE_GAME",
    "SET_GAME",
    "REQUEST_GAME_INFO",
    "END_GAME_ACTION",
  ] as const;
  export const TypeValue = enumify("BaseClient", _Types);
  export type Type = typeof TypeValue;

  export type JoinGameMessage = {
    type: Type["JOIN_GAME"];
    data: void;
  };

  export type LeaveGameMessage = {
    type: Type["LEAVE_GAME"];
    data: void;
  };

  export type RequestGameInfoMessage = {
    type: Type["REQUEST_GAME_INFO"];
    data: void;
  };

  export type EndGameActionMessage = {
    type: Type["END_GAME_ACTION"];
    data: EndGameAction;
  };

  export type Message =
    | JoinGameMessage
    | LeaveGameMessage
    | RequestGameInfoMessage
    | EndGameActionMessage;
}

export namespace BaseCommon {
  const _Types = ["SYNC", "DISCONNECT", "HEARTBEAT"] as const;
  export const TypeValue = enumify("BaseCommon", _Types);
  export type Type = typeof TypeValue;

  export type HeartbeatMessage = {
    type: Type["HEARTBEAT"];
    data: void;
  };

  export type SyncMessage = {
    type: Type["SYNC"];
    data: SyncStage;
  };

  export type DisconnectMessage = {
    type: Type["DISCONNECT"];
    data: {
      reason: string;
    };
  };

  export type Message = HeartbeatMessage | SyncMessage | DisconnectMessage;
}
